import {ValueObject} from '@s-ui/domain'

export class InformAgreedPriceTradeRequestValueObject extends ValueObject {
  #price
  #tradeId

  /**
   * @param {Object} data
   * @param {price} data.price
   * @param {tradeId} data.tradeId
   */

  static create = ({price, tradeId}) => {
    return new InformAgreedPriceTradeRequestValueObject({price, tradeId})
  }

  constructor({price, tradeId}) {
    super()

    this.#price = price
    this.#tradeId = tradeId
  }

  get price() {
    return this.#price
  }

  get tradeId() {
    return this.#tradeId
  }

  toJSON() {
    return {price: this.#price, tradeId: this.#tradeId}
  }

  toJSONBodyRequest() {
    return {agreedPrice: this.#price}
  }
}
